export enum UserRole {
  WORKSPACE_ADMIN = 'workspace_admin',
  DEPARTMENT_ADMIN = 'department_admin',
  USER = 'user',
}
